import React, { Fragment } from "react";

function MinMaxFilter({
  filter, onChange,val
}) {
  const {name} = filter;
  return (
      <div className="group" key={name} data-testid={filter.label}>
        <label>
          <span className="label">Min</span>
          <input
            type={filter.type}
            placeholder={filter.placeholder}
            value={val.min ? val.min : ""}
            onChange={(event) =>
               onChange(event, filter.value, "min")
            }
           />
         </label>
         <label>
         <span className="label">Max</span>
         <input
           type={filter.type}
           placeholder={filter.placeholder}
           value={val.max ? val.max : ""}
           onChange={(event) =>
             onChange(event, filter.value, "max")
           }
          />
        </label>
      </div>
  );
}

export default MinMaxFilter;


